import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  useMessageComposer,
  useStateStore,
  useTranslationContext,
} from 'stream-chat-react'
import MessagingCheckbox from './messaging-checkbox'

const stateSelector = state => ({
  showReplyInChannel: state.showReplyInChannel,
})

const useStyles = makeStyles({
  checkbox: {
    flexShrink: 0,
    width: 40,
    height: 40,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&.MuiCheckbox-root': {
      padding: 0,
    },
    '&.Mui-checked, &.MuiCheckbox-indeterminate': {
      color: '#0053ff',
    },
    '& .MuiSvgIcon-root': {
      fontSize: 24,
      width: 24,
      height: 24,
    },
  },
})

const MessagingSendToChannelCheckbox = () => {
  const classes = useStyles()
  const { t } = useTranslationContext()
  const messageComposer = useMessageComposer()
  const { showReplyInChannel } = useStateStore(
    messageComposer.state,
    stateSelector,
  )

  if (messageComposer.editedMessage || !messageComposer.threadId) {
    return null
  }

  const memberCount = Object.keys(messageComposer.channel.state.members).length
  const label =
    memberCount === 2
      ? t('Also send as a direct message')
      : t('Also send in channel')

  return (
    <div className="str-chat__send-to-channel-checkbox__container">
      <div className="str-chat__send-to-channel-checkbox__field">
        <MessagingCheckbox
          checked={showReplyInChannel}
          className={classes.checkbox}
          color="primary"
          id="send-to-channel-checkbox"
          inputProps={{ 'aria-label': label }}
          onChange={() => messageComposer.toggleShowReplyInChannel()}
        />
        <label htmlFor="send-to-channel-checkbox">{label}</label>
      </div>
    </div>
  )
}

export default MessagingSendToChannelCheckbox
